<template>
    <div class="container" id="QuranProgramsSchedules">
        <h2 class="text-center title"> {{ $t('home.quran_programs_schedules.title') }}</h2>
        <p class="text-center description">
            {{ $t('home.quran_programs_schedules.description') }}
        </p>
        <div class="row main-row">
            <div class="col-lg-6 col-12 order-lg-1 order-2">
                <div class="image-box">
                    <img src="@/assets/images/home/quranprogramsschedules/img1.webp" alt="">
                </div>
            </div>
            <div class="col-lg-6 col-12  d-flex flex-column justify-content-center align-items-start ps-4 order-lg-2 order-1">
                <h3 class="title">{{ $t('home.quran_programs_schedules.systemic') }}</h3>
                <p class="description">
                    {{ $t('home.quran_programs_schedules.systemic_paragraph') }}
                </p>
                <div class="d-flex mt-2 btns">
                    <a href="/dashboard/#/register-programs/quran" class="btn btn-primary ms-2 me-2"> {{ $t('home.quran_programs_schedules.join') }} </a>
                    <router-link to="/quran_programs" class="btn btn-outline-primary">  {{ $t('home.quran_programs_schedules.more') }} </router-link>

                </div>
            </div>
          
        </div>
        <div class="row">
            <div class="col-lg-6 col-12  d-flex flex-column justify-content-center align-items-start ps-4">
                <h3 class="title">{{ $t('home.quran_programs_schedules.general') }}</h3>
                <p class="description">
                    {{ $t('home.quran_programs_schedules.general_paragraph') }}
                </p>
                <div class="d-flex mt-2 btns">
                    <a href="/dashboard/#/register-programs/quran" class="btn btn-primary ms-2 me-2"> {{ $t('home.quran_programs_schedules.join') }}</a>
                    <router-link to="/quran_programs" class="btn btn-outline-primary"> {{ $t('home.quran_programs_schedules.more') }} </router-link>

                </div>
            </div>
            <div class="col-lg-6 col-12">
                <div class="image-box">
                    <img src="@/assets/images/home/quranprogramsschedules/img2.webp" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.container {
    margin-top: 40px;
}

.title {
    font-size: 36px;
    font-weight: 500;
}

.description {
    font-size: 18px;
    font-weight: 400;
    margin-top: 25px;
}

.image-box {
    border-radius: 20px;
    overflow: hidden;
    margin-bottom: 20px;
    object-fit: cover;

}

img {
    width: 635px;
    height: 390px;
    object-fit: cover;
}

.main-row {
    margin-top: 40px;
}

.title {
    font-size: 36px;
    font-weight: 500;
}

.description {
    font-size: 24px;
    font-weight: 400;
}

.btns {
    margin-bottom: 10px;
}
</style>